
export const contractTypeMapping: Record<string, string> = {
    'luxor-patient-case-analysis': 'discussion',
    'luxor-medical-report': 'medical-reports',
    'luxor-patient-guidance': 'guidance',
};

export const isTypeAvailable = (type: string, contractDiscussionCase: any, contractMedicalReports: any, contractGuidance: any) => {

    const contractType = contractTypeMapping[type];

    if (contractType === 'discussion') return !!contractDiscussionCase;
    if (contractType === 'medical-reports') return !!contractMedicalReports;
    if (contractType === 'guidance') return !!contractGuidance;

    return true;
};



export const hasAnyActiveContract = (contractDiscussionCase: any, contractMedicalReports: any, contractGuidance: any) => {
    return !!contractDiscussionCase || !!contractMedicalReports || !!contractGuidance;
};